import React from 'react';
import { FeeEditProvider } from './FeeEditContext';
import { FeesProvider } from './FeesContext';
import FeesList from './FeesList';

const FeesForm = ({ onChange }) => (
  <FeesProvider>
    <FeeEditProvider onChange={onChange}>
      <FeesList />
    </FeeEditProvider>
  </FeesProvider>
);

export default FeesForm;
